import React from 'react';
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';
import { Box, Link } from '@mui/material';
import { markdownProseSx } from './markdownProseSx';
import { stripCitationTokens } from '../../features/narrative-citations/parseCitations';

interface MarkdownContentProps {
  content: string;
}

export const MarkdownContent: React.FC<MarkdownContentProps> = ({ content }) => {
  // Citation tokens are review-only and meaningless as raw text — strip them so
  // they never surface as box glyphs on generic markdown surfaces (chat, logs,
  // HITL plan briefing). Surfaces that want clickable citations use CitedMarkdown.
  // Unescape literal \n characters that may come from JSON.
  const processedContent = stripCitationTokens(content).replace(/\\n/g, '\n');

  return (
    <Box sx={markdownProseSx}>
      <ReactMarkdown
        remarkPlugins={[remarkGfm]}
        components={{
          a: ({ href, children }) => (
            <Link href={href} target="_blank" rel="noopener noreferrer">
              {children}
            </Link>
          ),
        }}
      >
        {processedContent}
      </ReactMarkdown>
    </Box>
  );
};
